import { Companion_getInstanceno8hzdksos3n as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantSlackAccessMutationSelectionsClass;
function GrantSlackAccessMutationSelections() {
  if (GrantSlackAccessMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        GrantSlackAccessMutationSelections_instance = this;
        this.g6s_1 = listOf((new (Builder())('grantSlackAccess', Companion_getInstance().o70_1)).p47(listOf((new (Builder_0())(Companion_getInstance_0().u6p_1)).a48(new (CompiledVariable())('input')).l38())).l38());
      }
    }
    initMetadataForObject($, 'GrantSlackAccessMutationSelections');
    GrantSlackAccessMutationSelectionsClass = $;
  }
  return GrantSlackAccessMutationSelectionsClass;
}
var GrantSlackAccessMutationSelections_instance;
function GrantSlackAccessMutationSelections_getInstance() {
  if (GrantSlackAccessMutationSelections_instance === VOID)
    new (GrantSlackAccessMutationSelections())();
  return GrantSlackAccessMutationSelections_instance;
}
//region block: exports
export {
  GrantSlackAccessMutationSelections_getInstance as GrantSlackAccessMutationSelections_getInstance3mff5xgzwuml6,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutationSelections.mjs.map
